<template>
  <div
    class="cursor-pointer flex items-center select-none px-3 py-1.5 hover:bg-blue-alpha"
    :class="[active ? 'text-brand font-semibold' : '', nested ? 'text-sm' : '']"
  >
    <div
      class="w-6 h-6 rounded-full flex items-center justify-center mr-2 shrink-0"
    >
      <SvgIcon :icon="icon" class="text-brand" />
    </div>
    <span class="truncate" :class="{ 'font-medium': !nested }">
      {{ label }}
    </span>
  </div>
</template>

<script setup lang="ts">
import SvgIcon from '@/components/misc/SvgIcon'

defineProps<{
  icon: string
  label: string
  active?: boolean
  nested?: boolean
}>()
</script>
